
import axiosClient from "./axios.client";

const httpCall = async ({ url, method, body, headers = {}, params = {}, responseType, baseURL }) => {
  try {
    const { data, status } = await axiosClient.request({
      // baseURL: baseURL || axiosClient.defaults.baseURL, // Dynamic base URL support
      baseURL, // Dynamic base URL support
      url,
      method,
      data: body,
      params,
      headers,
      responseType,
    });
    return { data, status, errors: [] };
  } catch (error) {
    console.error("API Error:", error);
    const errorList = parseError(error);
    return {
      data: null,
      status: error.response?.status,
      errors: errorList,
    };
  }
};


const parseError = (error) => {
  return error?.response?.data?.errors || [{ message: "Something went wrong. Please try again." }];
};


const httpClient = {
  get: (args) => httpCall({ ...args, method: "GET" }),
  post: (args) => httpCall({ ...args, method: "POST" }),
  put: (args) => httpCall({ ...args, method: "PUT" }),
  delete: (args) => httpCall({ ...args, method: "DELETE" }),
  patch: (args) => httpCall({ ...args, method: "PATCH" }),
};

export default httpClient;
